import { useCallback, useContext } from 'react';
import api from 'api';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

export default function useMarkSessionRead() {
  const { markSessionRead } = useContext(CurrentUserContext);

  return useCallback(
    (sessionId: string, isExternalCommunication: boolean) => {
      if (!sessionId || isExternalCommunication) return;

      markSessionRead(sessionId);
      api.messages.readAllMessages(sessionId);
    },
    [markSessionRead],
  );
}
